<template>
  <div class="trace-view" :class="{ 'is-preview': preview }" :style="cssVars">
    <!-- 顶部标题栏 -->
    <div class="top" :style="{ background: headerBg }">
      <p>{{ cfg.welcome_text || '欢迎使用' }}</p>
      {{ companyName }}
      <p>{{ cfg.platform_text || '种业防伪追溯平台' }}</p>
    </div>

    <!-- 轮播图 -->
    <div v-if="banners.length" class="banner">
      <div class="banner-track" :style="{ transform: `translateX(${-safeIndex * 100}%)` }">
        <div v-for="(img, i) in banners" :key="'b' + i" class="banner-slide">
          <img :src="img" alt="" />
        </div>
      </div>
      <div v-if="banners.length > 1" class="banner-dots">
        <i v-for="(img, i) in banners" :key="'d' + i" :class="{ active: i === safeIndex }"
          @click="bannerIndex = i"></i>
      </div>
    </div>

    <!-- ============ 首页 ============ -->
    <template v-if="view === 'home'">
      <div class="title" :style="{ background: headerBg }">防伪验证信息</div>
      <div class="part1">
        <p>{{ verifyText }}</p>
      </div>

      <div class="title" :style="{ background: headerBg }">产品信息</div>
      <div class="part2">
        <div class="part2-line">
          <div v-if="cfg.logo" class="part2-logo">
            <img :src="cfg.logo" alt="" />
          </div>
          <div class="part2-p">
            <p>品种名称：{{ productName }}</p>
            <p v-if="producer">生产经营者：{{ producer }}</p>
            <p>单元识别代码：{{ info.code }}</p>
            <p>已查询次数：{{ info.scan_count || 0 }} 次</p>
            <p v-if="cfg.trace_url">追溯网址：<a :href="cfg.trace_url">{{ cfg.trace_url }}</a></p>
          </div>
        </div>
        <ul class="nav-btns">
          <li v-for="tab in tabs" :key="tab.key">
            <a href="javascript:;" :style="{ background: navBg }" @click="go(tab.key)">{{ tab.label }}</a>
          </li>
        </ul>
      </div>

      <div class="title" :style="{ background: headerBg }">联系方式</div>
      <div class="part3">
        <div class="part3-silde">
          <p v-if="enterprise.name" style="font-weight: 600;">{{ enterprise.name }}</p>
          <p v-if="cfg.wechat_text">企业微信：{{ cfg.wechat_text }}</p>
          <p v-if="enterprise.phone">企业电话：<a :href="'tel:' + enterprise.phone">{{ enterprise.phone }}</a></p>
          <p v-if="enterprise.address">地址：{{ enterprise.address }}</p>
          <p v-if="enterprise.website">官网：{{ enterprise.website }}</p>
        </div>
        <div v-if="cfg.qrcode_image" class="part3-ewm">
          <img :src="cfg.qrcode_image" alt="" />
        </div>
      </div>

      <footer :style="{ background: navBg }">
        <a href="javascript:;">{{ cfg.footer_text || '技术支持' }}</a>
      </footer>
    </template>

    <!-- ============ 三个可编辑 HTML 子页 ============ -->
    <div v-else class="rich" v-html="currentHtml"></div>

    <!-- 子页底部固定导航 -->
    <div v-if="view !== 'home'" class="fix" :style="{ background: navBg }">
      <ul>
        <li><a href="javascript:;" @click="go('home')">首页</a></li>
        <li v-for="tab in tabs" :key="tab.key">
          <a href="javascript:;" :class="{ active: view === tab.key }" @click="go(tab.key)">{{ tab.label }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { DEFAULT_DETAIL_HTML } from '../constants'

export default {
  name: 'TraceView',
  props: {
    info: { type: Object, default: () => ({}) },
    preview: { type: Boolean, default: false },
  },
  data() {
    return {
      view: 'home',
      bannerIndex: 0,
      bannerTimer: null,
      tabs: [
        { key: 'detail', label: '追溯信息' },
        { key: 'about', label: '公司简介' },
        { key: 'atlas', label: '田间照片' },
      ],
    }
  },
  computed: {
    cfg() {
      return (this.info && this.info.template) || {}
    },
    enterprise() {
      return this.cfg.enterprise || {}
    },
    companyName() {
      return this.cfg.company_name || this.enterprise.name || '产品溯源'
    },
    productName() {
      return this.info.product_name || '示例产品'
    },
    producer() {
      return this.cfg.producer || this.enterprise.name || ''
    },
    headerBg() {
      return this.cfg.header_bg || this.cfg.theme_color || '#009b4c'
    },
    navBg() {
      return this.cfg.nav_bg || '#159442'
    },
    cssVars() {
      return { '--hb': this.headerBg, '--nb': this.navBg }
    },
    banners() {
      return (this.cfg.gallery || []).filter(Boolean)
    },
    safeIndex() {
      const n = this.banners.length
      return n ? ((this.bannerIndex % n) + n) % n : 0
    },
    verifyText() {
      const parts = []
      if (this.info.code) parts.push(this.info.code)
      parts.push(`该防伪码已查询过 ${this.info.scan_count || 0} 次`)
      if (this.info.first_scan_time) {
        parts.push(`首次查询时间是 ${this.formatTime(this.info.first_scan_time)}`)
      }
      const suffix = this.cfg.verify_text
        || '真诚感谢您的大力支持与信任，您所查询的为正宗产品！'
      return parts.join('，') + '，' + suffix
    },
    currentHtml() {
      let html = ''
      if (this.view === 'detail') html = this.cfg.detail_html || DEFAULT_DETAIL_HTML
      else if (this.view === 'about') html = this.cfg.about_html || '<p>公司简介资料整理中……</p>'
      else if (this.view === 'atlas') html = this.cfg.atlas_html || '<p>田间照片资料整理中……</p>'
      return this.applyTokens(html)
    },
  },
  watch: {
    'banners.length'() {
      this.bannerIndex = 0
      this.startBanner()
    },
  },
  methods: {
    go(key) {
      this.view = key
      if (!this.preview) {
        const q = { ...this.$route.query, p: key === 'home' ? undefined : key }
        this.$router.replace({ query: q }).catch(() => {})
        window.scrollTo(0, 0)
      }
    },
    setViewFromRoute() {
      if (this.preview) return
      const p = this.$route.query.p
      this.view = ['detail', 'about', 'atlas'].includes(p) ? p : 'home'
    },
    // 把 {code} {scan_count} 等占位符替换成真实数据
    applyTokens(html) {
      if (!html) return ''
      const map = {
        code: this.info.code || '',
        product_name: this.productName,
        batch_number: this.info.batch_number || '',
        production_date: this.info.production_date || '',
        scan_count: this.info.scan_count || 0,
        first_scan_time: this.formatTime(this.info.first_scan_time),
        last_scan_time: this.formatTime(this.info.last_scan_time),
        company_name: this.companyName,
        producer: this.producer,
      }
      return String(html).replace(/\{(\w+)\}/g, (m, k) => (k in map ? map[k] : m))
    },
    formatTime(val) {
      if (!val) return ''
      const d = new Date(val)
      if (Number.isNaN(d.getTime())) return val
      const pad = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
        `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },
    startBanner() {
      this.stopBanner()
      if (this.banners.length > 1) {
        this.bannerTimer = setInterval(() => {
          this.bannerIndex = (this.bannerIndex + 1) % this.banners.length
        }, 3500)
      }
    },
    stopBanner() {
      if (this.bannerTimer) {
        clearInterval(this.bannerTimer)
        this.bannerTimer = null
      }
    },
  },
  mounted() {
    this.setViewFromRoute()
    this.startBanner()
  },
  beforeDestroy() {
    this.stopBanner()
  },
}
</script>

<style scoped>
.trace-view {
  position: relative;
  max-width: 480px;
  margin: 0 auto;
  min-height: 100%;
  padding-bottom: 44px;
  background: #fff;
  font-family: "Microsoft YaHei", "PingFang SC", Arial, sans-serif;
}

.top { padding: 10px 5px; font-size: 16px; line-height: 20px; color: #fff; text-align: center; }
.top p { margin: 0; }

/* 轮播 */
.banner { position: relative; width: 100%; overflow: hidden; }
.banner-track { display: flex; transition: transform 0.4s ease; }
.banner-slide { flex: 0 0 100%; width: 100%; }
.banner-slide img { display: block; width: 100%; }
.banner-dots { position: absolute; left: 0; bottom: 8px; width: 100%; text-align: center; }
.banner-dots i {
  display: inline-block; width: 8px; height: 8px; margin: 0 3px;
  border-radius: 50%; background: #b4b3b3; cursor: pointer;
}
.banner-dots i.active { background: rgb(230, 33, 41); }

.title { margin: 5px 0; padding: 0 15px; font-size: 14px; line-height: 30px; color: #fff; }

.part1 { padding: 10px; font-size: 12px; line-height: 20px; color: #000; text-indent: 2em; }
.part1 p { margin: 0; }

.part2 { padding: 10px; }
.part2-line { display: flex; justify-content: space-between; padding: 10px 0; }
.part2-logo { flex-shrink: 0; width: 72px; }
.part2-logo img { width: 100%; }
.part2-p { flex-grow: 1; padding-left: 10px; font-size: 12px; line-height: 20px; color: #000; }
.part2-p p { margin: 0; }
.part2-p a { color: #00a34a; word-break: break-all; }

.nav-btns { display: flex; justify-content: space-between; padding: 15px 0; margin: 0; list-style: none; flex-wrap: wrap; gap: 8px 0; }
.nav-btns li { list-style: none; }
.nav-btns li a {
  display: block; padding: 0 12px; font-size: 14px; line-height: 30px;
  color: #fff; text-align: center;
}

.part3 { display: flex; justify-content: space-between; padding: 10px; }
.part3-silde { flex-grow: 1; padding-right: 10px; font-size: 14px; line-height: 24px; color: #000; }
.part3-silde p { margin: 0; }
.part3-silde a { color: #000; }
.part3-ewm { flex-shrink: 0; width: 90px; }
.part3-ewm img { width: 100%; }

footer { text-align: center; }
footer a { font-size: 14px; line-height: 24px; color: #fff; }

/* 可编辑 HTML 子页统一样式 (v-html 内容需用深度选择器) */
.rich { padding: 10px; font-size: 14px; line-height: 24px; color: #000; }
.rich >>> p { text-indent: 2em; margin: 0 0 8px; }
.rich >>> img { max-width: 100%; display: block; text-indent: 0; margin: 6px 0; }
.rich >>> a { color: #00a34a; }
/* 绿色小标题条 */
.rich >>> .tt {
  margin: 8px 0 4px; padding: 0 15px; font-size: 14px; line-height: 30px;
  color: #fff; background: var(--hb, #009b4c); text-indent: 0;
}
/* 一行 名称 / 值 */
.rich >>> .dl {
  display: flex; justify-content: space-between; align-items: flex-start;
  padding: 6px 0; border-bottom: 1px solid #efefef; text-indent: 0;
}
.rich >>> .dl span { color: #333; flex-shrink: 0; }
.rich >>> .dl b { color: #000; font-weight: 600; text-align: right; padding-left: 10px; word-break: break-all; }

/* 底部导航 */
.fix { position: fixed; z-index: 10; left: 0; bottom: 0; width: 100%; }
.fix ul { display: flex; justify-content: space-between; padding: 0 5px; margin: 0 auto; max-width: 480px; }
.fix ul li { list-style: none; }
.fix ul li a { display: block; padding: 0 5px; font-size: 14px; line-height: 36px; color: #fff; text-align: center; }
.fix ul li a.active { font-weight: 700; text-decoration: underline; }

/* 预览模式: 底部导航容器内吸底 */
.is-preview .fix { position: sticky; }
.is-preview .fix ul { max-width: none; }
</style>
